import { AuthenticatedRoute, RouteErrorFallback } from '@core/components';
import { CommunityManagementPage } from '@system-config/community-management/pages';
import { LabelManagementPage } from '@system-config/label-management/pages';
import { PolicyManagementPage } from '@system-config/policy-management/pages';
import type { RouteObject } from 'react-router-dom';

/**
 * Get route configuration for the System Config domain
 * @returns Array of route objects for the System Config domain
 */
export function getRouteConfig(): RouteObject[] {
  return [
    {
      path: 'system-config',
      element: <AuthenticatedRoute requiresSystemAdmin />,
      children: [
        {
          path: 'community-management',
          handle: { breadcrumb: 'Community Management' },
          element: <CommunityManagementPage />,
          errorElement: <RouteErrorFallback />,
        },
        {
          path: 'label-management',
          handle: { breadcrumb: 'Label Management' },
          element: <LabelManagementPage />,
          errorElement: <RouteErrorFallback />,
        },
        {
          path: 'policy-management',
          handle: { breadcrumb: 'Policy Management' },
          element: <PolicyManagementPage />,
          errorElement: <RouteErrorFallback />,
        },
      ],
    },
    // Keep backward compatibility for existing routes
    {
      path: 'label-management',
      element: <AuthenticatedRoute requiresSystemAdmin />,
      handle: { breadcrumb: 'Label Management' },
      children: [
        {
          index: true,
          element: <LabelManagementPage />,
        },
      ],
    },
    {
      path: 'policy-management',
      element: <AuthenticatedRoute requiresSystemAdmin />,
      handle: { breadcrumb: 'Policy Management' },
      children: [
        {
          index: true,
          element: <PolicyManagementPage />,
        },
      ],
    },
  ];
}
